var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cwp-status-marker"},[_c('span',{class:`cwp-status-marker__icon cwp-status-marker__icon-${_vm.status.replace(/ /g, '-')}`}),_c('span',{staticClass:"cwp-status-marker__title"},[_vm._v(_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }